import { createContext, useContext, useEffect } from "react";

import PropTypes from "prop-types";

import useLazyClassroomGetList from "@/classrooms/useLazyClassroomGetList";

const propTypes = {
  children: PropTypes.node,
};

export const ClassroomsQueryContext = createContext({});

const useClassroomsContext = () => {
  const classroomsQueryCtx = useContext(ClassroomsQueryContext);

  if (classroomsQueryCtx === undefined) {
    throw new Error(
      "useClassroomsContext must be used within a ClassroomsProvider.",
    );
  }

  return classroomsQueryCtx;
};

export const ClassroomsProvider = ({ children }) => {
  const [fetchClassrooms, { data: classrooms = [], error, loading }] =
    useLazyClassroomGetList();

  const contextData = { fetchClassrooms, classrooms, error, loading };

  useEffect(() => {
    fetchClassrooms();
  }, []);

  return (
    <ClassroomsQueryContext.Provider value={contextData}>
      {children}
    </ClassroomsQueryContext.Provider>
  );
};

ClassroomsProvider.propTypes = propTypes;

export default useClassroomsContext;
